import { getAccessToken, refreshSession } from "../auth/session";

export const fetchWithRetry = async (url, options = {}, retries = 3, delay = 200) => {
    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            const headers = new Headers(options.headers || {});
            const token = getAccessToken();
            if (token) headers.set("Authorization", `Bearer ${token}`);
            let response = await fetch(url, { ...options, headers, credentials: "include" });

            if (response.status === 401 && !url.includes("/api/auth/")) {
                await refreshSession();
                headers.set("Authorization", `Bearer ${getAccessToken()}`);
                response = await fetch(url, { ...options, headers, credentials: "include" });
            }

            // If the response is OK, return it
            if (response.ok) {
                return response;
            }

            if (response.status < 500) return response;
            throw new Error(`Error: ${response.status}`);

        } catch (error) {
            console.error(`Attempt ${attempt} failed:`, error.message);

            // If this was the last attempt, rethrow the error
            if (attempt === retries) {
                throw error;
            }

            // Wait before retrying
            await new Promise(resolve => setTimeout(resolve, delay * attempt));
        }
    }
};

export const fetchRoster = async () => {
    const headers = {
        'Content-Type': 'application/json'
    };

    try {
        const response = await fetchWithRetry(`${process.env.REACT_APP_STATS_BACKEND_ADDRESS || "/api/stats"}/player_roster/extended`, {
            headers: headers,
            method: "GET"
        });

        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(`Failed to fetch roster: ${errorResponse.message}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Roster fetch error:", error.message);
        throw new Error("Failed to fetch roster.");
    }
};


export const fetchGrandPrixList = async () => {
    const headers = {
        'Content-Type': 'application/json'
    };

    try {
        const response = await fetchWithRetry(`${process.env.REACT_APP_STATS_BACKEND_ADDRESS || "/api/stats"}/grand_prix`, {
            headers: headers,
            method: "GET"
        });

        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(`Failed to fetch Grand Prix List: ${errorResponse.message}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Grand Prix List fetch error:", error.message);
        throw new Error("Failed to fetch Grand Prix List.");
    }
};
